<div class="mgmt-page">
  <div class="page-header">
    <div class="page-header__left">
      <span class="page-tag">B&S</span>
      <h1 class="page-title">Banners And Sliders</h1>
      <p class="page-sub">Manage promotional banners, sliders and campaign images</p>
    </div>
    <button class="btn-add" (click)="openModal()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
        <line x1="12" y1="5" x2="12" y2="19"/>
        <line x1="5" y1="12" x2="19" y2="12"/>
      </svg>
      Add Banner Or Slider
    </button>
  </div>

  <div *ngIf="items.length > 0; else emptyState">
    <div class="banner-group" *ngFor="let group of items; trackBy: trackByGroup">
      <div class="banner-group__header">
        <div>
          <h2>{{ group.type }}</h2>
          <p>Language: {{ group.lang }} | Value: {{ group.value }}</p>
        </div>
      </div>

      <div class="items-grid" *ngIf="group.banners?.length > 0; else noGroupItems">
        <div class="item-card"
             *ngFor="let item of group.banners; let i = index; trackBy: trackByBanner"
             [style.animation-delay]="i * 0.06 + 's'">

          <div class="item-card__image">
            <img [src]="(item.photo | ImageUrlPipe)" [alt]="item.title" *ngIf="item.photo" appImageFallback />

            <div class="item-card__no-img" *ngIf="!item.photo">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <rect x="3" y="3" width="18" height="18" rx="2"/>
                <circle cx="8.5" cy="8.5" r="1.5"/>
                <polyline points="21 15 16 10 5 21"/>
              </svg>
            </div>

            <span class="lang-badge">{{ item.language_code || group.lang }}</span>
          </div>

          <div class="item-card__body">
            <h3 class="item-card__title">{{ item.title || '—' }}</h3>

            <a class="item-card__link" *ngIf="item.link" [href]="item.link" target="_blank">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                <polyline points="15 3 21 3 21 9"/>
                <line x1="10" y1="14" x2="21" y2="3"/>
              </svg>
              {{ item.link }}
            </a>
          </div>

          <div class="item-card__actions">
            <button class="btn-icon btn-icon--edit" (click)="openModal(item.id, group)" title="Edit">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
              </svg>
            </button>

            <!-- ✅ بنبعت الـ group كامل عشان ناخد منه اللغة والـ type -->
            <button class="btn-icon btn-icon--delete" (click)="confirmDelete(item, group)" title="Delete">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                <path d="M10 11v6"/>
                <path d="M14 11v6"/>
                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <ng-template #noGroupItems>
        <div class="empty-state small">
          <p>No banners in this group</p>
        </div>
      </ng-template>
    </div>
  </div>

  <div class="pagination-controls" *ngIf="totalPages > 0">
    <div class="pagination-info">
      Page {{ currentPage }} of {{ totalPages }}
    </div>

    <div class="pagination-buttons">
      <!-- ✅ كان previousPage() غير موجود - الصح prevPage() -->
      <button
        (click)="prevPage()"
        [disabled]="currentPage === 1"
        class="pagination-btn">
        ‹ Previous
      </button>

      <div class="page-numbers">
        <button
          *ngFor="let page of pages"
          (click)="goToPage(page)"
          [class.active]="page === currentPage"
          class="page-btn">
          {{ page }}
        </button>
      </div>

      <button
        (click)="nextPage()"
        [disabled]="currentPage === totalPages"
        class="pagination-btn">
        Next ›
      </button>
    </div>

    <div class="items-per-page">
      <label>Show:</label>
      <!-- ✅ تصحيح الخيار الافتراضى -->
      <select [value]="pageSize" (change)="onItemsPerPageChange($event)">
        <option [value]="pageSize">{{ pageSize }}</option>
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="25">25</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>
    </div>
  </div>

  <ng-template #emptyState>
    <div class="empty-state">
      <div class="empty-state__icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2">
          <rect x="2" y="5" width="20" height="14" rx="2"/>
          <line x1="2" y1="10" x2="22" y2="10"/>
        </svg>
      </div>
      <h3>No banners yet</h3>
      <p>Add your first banner to get started</p>
      <button class="btn-add" (click)="openModal()">Add Banner</button>
    </div>
  </ng-template>

  <div class="overlay" *ngIf="showDeleteConfirm" (click)="cancelDelete()">
    <div class="confirm-modal" (click)="$event.stopPropagation()">
      <div class="confirm-modal__icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" y1="8" x2="12" y2="12"/>
          <line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
      </div>
      <h4>Delete Banner?</h4>
      <p>This action cannot be undone.</p>
      <div class="confirm-modal__actions">
        <button class="btn-cancel" (click)="cancelDelete()">Cancel</button>
        <button class="btn-danger" (click)="deleteItem()">Delete</button>
      </div>
    </div>
  </div>

  <div class="overlay" *ngIf="showModal" (click)="closeModal()">
    <div class="form-modal" (click)="$event.stopPropagation()">
      <div class="form-modal__header">
        <div>
          <span class="page-tag">{{ editingItem ? 'EDIT' : 'NEW' }}</span>
          <h3>{{ editingItem ? 'Edit Banner' : 'Add Banner' }}</h3>
        </div>
        <button class="modal-close" (click)="closeModal()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>

      <div class="form-modal__body">
        <div class="select-field" *ngIf="!editingItem">
          <label>Type</label>
          <ng-select
              [items]="types"
              placeholder="Choose Type"
              [searchable]="true"
              [clearable]="true"
              [(ngModel)]="selected_type">
          </ng-select>
        </div>
        <div class="select-field" *ngIf="editingItem">
          <label>Type</label>
          <h3>{{ editingItem?.type }}</h3>
        </div>

        <div class="form-field">
          <label>Link URL</label>
          <input type="url" class="form-input" [(ngModel)]="form.link" />
        </div>

        <div class="form-field" *ngIf="!editingItem">
          <label>Images</label>

          <div class="img-upload" [class.has-image]="imagePreviews.length > 0">
            <div class="selected-banner-images" *ngIf="imagePreviews.length > 0">
              <div class="selected-banner-image" *ngFor="let img of imagePreviews; let i = index">
                <img
                  [src]="img.startsWith('data:image') ? img : (img | ImageUrlPipe)"
                  appImageFallback
                />

                <button
                  type="button"
                  class="img-remove"
                  (click)="removeImage(i)"
                >
                  ×
                </button>
              </div>
            </div>

            <div class="img-upload__placeholder" *ngIf="imagePreviews.length === 0">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="17 8 12 3 7 8"/>
                <line x1="12" y1="3" x2="12" y2="15"/>
              </svg>
              <span>Choose images from gallery</span>
              <small>يمكن اختيار أكثر من صورة</small>
            </div>

            <button
              type="button"
              class="btn-open-gallery"
              (click)="openGalleryModal()"
            >
              {{ imagePreviews.length > 0 ? 'Change images from gallery' : 'Choose from gallery' }}
            </button>
          </div>
        </div>
      </div>

      <div class="form-modal__footer">
        <button class="btn-cancel" (click)="closeModal()">Cancel</button>
        <button class="btn-save" [disabled]="saving" (click)="saveItem()">
          <span *ngIf="saving" class="spinner"></span>
          {{ saving ? 'Saving…' : (editingItem ? 'Update Banner' : 'Add Banner') }}
        </button>
      </div>
    </div>
  </div>

  <div class="overlay" *ngIf="showGalleryModal" (click)="closeGalleryModal()">
    <div class="gallery-modal" (click)="$event.stopPropagation()">
      <div class="gallery-modal__header">
        <h3>Choose Banner Image</h3>

        <button
          type="button"
          class="modal-close"
          (click)="closeGalleryModal()"
        >
          ×
        </button>
      </div>

      <div class="gallery-modal__body">
        <app-gallery-picker
          [selectedImages]="selectedPhotos"
          (selectedImagesChange)="onGalleryImagesChange($event)">
        </app-gallery-picker>
      </div>

      <div class="gallery-modal__footer">
        <button
          type="button"
          class="btn-cancel"
          (click)="closeGalleryModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>